/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Button_CreateInputs */



/**
* | output |
* | --- |
* | "Create" |
*
* @param {Spaces_Wizard_Button_CreateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_button_create = /** @type {((inputs?: Spaces_Wizard_Button_CreateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Button_CreateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellen")
	return /** @type {LocalizedString} */ ("Create")
});